import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Member } from '../../../core/models/member/member'
import type { FeedbackType } from '@/core/models/feedback-type'
import type { Scale } from '@/core/models/scale'

export const useMultipleFeedback = (surveyId: string) => {
  const { data, status, load } = useGet<GiveFeedbackToMultipleReceivers>(
    `feedback/structured/${surveyId}`,
  )

  onMounted(() => {
    load()
  })

  return { data, status, load }
}

export interface GiveFeedbackToMultipleReceivers {
  readonly id: string
  readonly title: string | null
  readonly message: JSON
  readonly isSuperpower: boolean
  readonly timeEstimation: number
  readonly questionGroups: ReadonlyArray<{
    readonly id: string
    readonly title?: string
    readonly labels: ReadonlyArray<{
      id: string
      title: string
      key: string
      icon: string
      description?: string
    }>
    readonly feedbackType: FeedbackType
    readonly scale?: Scale
    readonly questions: ReadonlyArray<{
      readonly id: string
      readonly content: string
      readonly scaleItemDescriptions: ReadonlyArray<string>
    }>
  }>
  readonly tandems: ReadonlyArray<{
    readonly receiver: Member
    readonly isFinished: boolean
    readonly supervisors?: ReadonlyArray<Member>
    readonly feedbacks: ReadonlyArray<{
      readonly questionId: string
      readonly id: string
      readonly text?: JSON
      readonly value?: number
    }>
  }>
}
